import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Company } from '../../models/company';

@Injectable({
  providedIn: 'root',
})
export class ShopifyService {
  private readonly url = `${environment.apiV2.url}/api/shopify`;

  constructor(private http: HttpClient) {}

  setState(email: string): Observable<any> {
    return this.http.post(`${this.url}/oauth/state`, {
      userId: email,
    });
  }

  sync({
    companyId,
    userId,
  }: {
    companyId: string;
    userId: string;
  }) {
    return this.http.post<{status: string}>(`${this.url}/sync`, {
      companyId,
      userId,
    });
  }

  authenticate({
    code,
    shop,
    userId,
  }: {
    code: string;
    shop: string;
    userId: string;
  }) {
    return this.http.post<Company>(`${this.url}/authenticate`, {
      code,
      shop,
      userId,
    });
  }
}
